module.exports = __webpack_public_path__ + "img/home_3.e81def02.jpg";